import { getWebsiteType } from "../../utils/utils.js";
import Link from "next/link";
import {
  InternalLinkIcon,
  DownloadIcon,
  ExternalLinkIcon,
  ChooseLocationIcon,
  TalkToAnExpertIcon,
  ExternalLinkSimpleIcon,
  HamburgerMenuIcon,
  SearchIcon,
  GlobeIcon,
} from "./Icons";
import { prefix } from "../../utils/utils.js";
import { useEffect } from "react";
export const ButtonElement = ({
  label,
  size,
  variant,
  type,
  value,
  externallink,
  internalLink,
  newTab,
  extraClass = "",
  isEditor = false,
  isInverted = false,
  onClick,
  groupWebsiteLink,
  extraClassIcon = "",
}) => {
  const websiteType = getWebsiteType(isEditor);

  // const fileUrl = value && value.url ? value.url : "";
  const fileName = value && value.name ? value.name : "";

  const btnVariant = (() => {
    switch (variant) {
      case "primary":
        return isInverted
          ? "btn-primary bg-white text-gray-900 border border-solid border-transparent media-hover:hover:bg-gray-200 flex items-center gap-8 w-fit rounded-xxxs font-medium duration-300"
          : "btn-primary bg-gray-900 text-white border border-solid border-transparent media-hover:hover:bg-gray-800 flex items-center gap-8 w-fit rounded-xxxs font-medium duration-300";
      case "secondary":
        return isInverted
          ? "btn-secondary bg-white/10 text-white border border-solid border-white media-hover:hover:bg-white/30 flex items-center gap-8 w-fit rounded-xxxs font-medium duration-300"
          : "btn-secondary bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-white flex items-center gap-8 w-fit rounded-xxxs font-medium duration-300";
      case "link":
        return isInverted
          ? "btn-link flex items-center gap-8 w-fit h-full min-h-24 text-white rounded-xxxs font-medium text-xxs"
          : "btn-link flex items-center gap-8 w-fit h-full min-h-24 text-gray-900 rounded-xxxs font-medium text-xxs";
      default:
        return "";
    }
  })();

  const btnSize = (() => {
    switch (size) {
      case "large":
        return "px-24 py-12 text-xs";
      case "default":
        return "px-20 py-10 text-xxs";
      case "small":
        return "px-20 py-10 text-xxs";
      default:
        return "";
    }
  })();

  const getIconColor = (websiteType, variant) => {
    if (
      websiteType === "petrotec-group" &&
      variant === "primary" &&
      !isInverted
    ) {
      return "stroke-white";
    } else if (
      websiteType === "petrotec-group" &&
      variant === "primary" &&
      isInverted
    ) {
      return "stroke-gray-900";
    } else if (
      websiteType === "petrotec-group" &&
      variant === "secondary" &&
      !isInverted
    ) {
      return "stroke-gray-900";
    } else if (
      websiteType === "petrotec-group" &&
      variant === "secondary" &&
      isInverted
    ) {
      return "stroke-white";
    } else if (
      websiteType === "petrotec-group" &&
      variant === "link" &&
      !isInverted
    ) {
      return "stroke-gray-900";
    } else if (
      websiteType === "petrotec-group" &&
      variant === "link" &&
      isInverted
    ) {
      return "stroke-white";
    } else {
      return "stroke-theme-color";
    }
  };

  const btnIcon = (() => {
    const iconClass = getIconColor(websiteType, variant);

    switch (type) {
      case "internal":
        return <InternalLinkIcon extraClass={iconClass} />;
      case "custom":
        return <ExternalLinkIcon extraClass={iconClass} />;
      case "file":
        return <DownloadIcon extraClass={iconClass} />;
      case "special":
        switch (externallink) {
          case "talk_to_an_expert":
            return <TalkToAnExpertIcon extraClass={iconClass} />;
          case "region_selection":
            return <ChooseLocationIcon extraClass={iconClass} />;
          case "region_selection_drawer":
            return <GlobeIcon extraClass={iconClass} />;
          case "spontaneous_application":
          default:
            return <ExternalLinkIcon extraClass={iconClass} />;
        }
      case "external":
        return (
          <ExternalLinkSimpleIcon
            extraClass={`${iconClass} ${extraClassIcon}`}
          />
        );
      default:
        return null;
    }
  })();

  const buttonClasses = `${btnVariant} ${
    variant === "link" ? "" : btnSize
  } ${extraClass}`.trim();

  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  // Creates individual events for each special button for the AppDrawer.js to hear
  const handleRegionSelection = () => {
    const event = new CustomEvent("openRegionSelection");
    window.dispatchEvent(event);
  };

  const handleSpontaneousApplication = () => {
    const event = new CustomEvent("openSpontaneousApplication");
    window.dispatchEvent(event);
  };

  const handleSummerCamp = () => {
    const event = new CustomEvent("openSummerCamp");
    window.dispatchEvent(event);
  };

  const handleBecomeDistributor = () => {
    const event = new CustomEvent("openBecomeDistributor");
    window.dispatchEvent(event);
  };

  if (type === "special" && externallink === "talk_to_an_expert") {
    return (
      <a href="#talk-to-an-expert" className={buttonClasses} aria-label={label}>
        <span>{label}</span>
        {btnIcon}
      </a>
    );
  }

  if (type === "special" && externallink === "region_selection") {
    return (
      <button
        onClick={handleRegionSelection}
        className={buttonClasses}
        aria-label={label}
      >
        <span>{label}</span>
        {btnIcon}
      </button>
    );
  }

  if (type === "special" && externallink === "spontaneous_application") {
    return (
      <button
        onClick={handleSpontaneousApplication}
        className={buttonClasses}
        aria-label={label}
      >
        <span>{label}</span>
        {btnIcon}
      </button>
    );
  }

  if (type === "special" && externallink === "petrotec_summer_camp") {
    return (
      <button
        onClick={handleSummerCamp}
        className={buttonClasses}
        aria-label={label}
      >
        <span>{label}</span>
        {btnIcon}
      </button>
    );
  }

  if (type === "special" && externallink === "become_distributor") {
    return (
      <button
        onClick={handleBecomeDistributor}
        className={buttonClasses}
        aria-label={label}
      >
        <span>{label}</span>
        {btnIcon}
      </button>
    );
  }

  if (type === "special" && externallink === "region_selection_drawer") {
    return (
      <Link
        href={prefix(groupWebsiteLink)}
        as={prefix(groupWebsiteLink)}
        className={buttonClasses}
        aria-label={label || ""}
      >
        <span>{label}</span>
        {btnIcon}
      </Link>
    );
  }

  if (type === "file") {
    return (
      <a
        href={value?.url ? value.url : value}
        download={fileName}
        className={buttonClasses}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Download ${fileName}`}
      >
        <span>{label}</span>
        {btnIcon}
      </a>
    );
  }

  return (
    <Link
      href={onClick ? "#" : prefix(externallink) || prefix(internalLink)}
      // as={prefix(internalLink)}
      target={newTab ? "_blank" : "_self"}
      className={`group ${buttonClasses}`}
      onClick={handleClick}
      aria-label={label || ""}
    >
      <span
        className={
          variant === "link"
            ? isInverted
              ? "underline decoration-transparent media-hover:group-hover:decoration-white underline-offset-4 duration-300"
              : "underline decoration-transparent media-hover:group-hover:decoration-gray-900 underline-offset-4 duration-300"
            : undefined
        }
      >
        {/* {console.log(externallink)} */}
        {label}
      </span>
      {btnIcon}
    </Link>
  );
};

export const ButtonLink = ({ href, text, icon }) => {
  return (
    <Link
      href={prefix(href)}
      as={prefix(href)}
      aria-label={text || ""}
      className="group btn-link flex items-center gap-8 w-fit text-gray-900 rounded-xxxs font-medium text-xxs"
    >
      <span className="underline decoration-transparent media-hover:group-hover:decoration-gray-900 underline-offset-4 duration-300">
        {text}
      </span>
      {icon}
    </Link>
  );
};

export const HamburgerMenuButton = ({ onClick, text }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      aria-label={text}
      className="flex 1024:hidden items-center h-full gap-x-10 border-b-2 border-transparent media-hover:hover:border-gray-900 duration-300"
    >
      <span className="sr-only text-xxs font-medium leading-115 tracking-05 w-max">
        {text}
      </span>
      <HamburgerMenuIcon />
    </button>
  );
};

export const NavButtonSearch = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      aria-label="Search"
      className="h-full media-hover:hover:opacity-60 duration-300"
    >
      <SearchIcon />
    </button>
  );
};

export const NavButtonAction = ({ onMouseEnter, text, active }) => {
  return (
    <button
      onMouseEnter={onMouseEnter}
      type="button"
      aria-label={text}
      className={`flex items-center gap-x-6 border-b-2 border-transparent media-hover:hover:border-gray-900 duration-300 ${
        active ? "!border-gray-900" : "border-transparent"
      }`}
    >
      <span className="text-xxs font-medium leading-115 tracking-05 w-max">
        {text}
      </span>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 7.5L10 12.5L15 7.5"
          stroke="#303337"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

const getLinkType = (href) => {
  if (href.charAt(0) == "/") {
    return "internal";
  } else {
    return "external";
  }
};

export const NavButtonLink = ({ href, text, onClick, onMouseEnter }) => {
  const linkType = getLinkType(href);
  return (
    <Link
      href={prefix(href)}
      as={prefix(href)}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      aria-label={text || ""}
      target={linkType === "internal" ? "_self" : "_blank"}
      className="flex items-center gap-x-6 border-b-2 border-transparent media-hover:hover:border-gray-900 duration-300"
    >
      <span className="text-xxs font-medium leading-115 tracking-05 w-max">
        {text}
      </span>
      {linkType === "external" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.5 14L13.5 7M13.5 7V13.72M13.5 7H6.78"
            stroke="#303337"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </Link>
  );
};

export const SubNavButtonLink = ({ href, text, onClick }) => {
  return (
    <Link
      href={prefix(href)}
      as={prefix(href)}
      onClick={onClick}
      aria-label={text || ""}
      className="group flex items-center gap-x-8"
    >
      <span className="text-xxs font-medium">{text}</span>
      <InternalLinkIcon extraClass="opacity-0 media-hover:group-hover:opacity-100 stroke-gray-900 duration-300" />
    </Link>
  );
};

export const SecondaryButtonLink = ({
  href,
  onClick,
  text,
  icon,
  extraClass = "",
}) => {
  return (
    <Link
      href={prefix(href)}
      as={prefix(href)}
      onClick={onClick}
      aria-label={text || ""}
      className={`btn-secondary px-20 py-10 bg-gray-100 text-gray-900 border border-solid border-gray-300 media-hover:hover:bg-white flex items-center gap-8 w-fit rounded-xxxs duration-300 ${extraClass}`}
    >
      <span className="text-xxs font-medium">{text}</span>
      {icon}
    </Link>
  );
};

export const SubmitFormButton = ({
  disabled = false,
  text,
  onClick,
  externalLink = false,
}) => {
  const websiteType = getWebsiteType(false);
  return (
    <button
      disabled={disabled}
      type="submit"
      onClick={onClick}
      aria-label="Submit"
      className="btn-primary submit-form px-24 py-12 w-full justify-center text-xs bg-gray-900 text-white border border-solid border-transparent media-hover:hover:bg-gray-800 flex items-center gap-8 w-fit rounded-xxxs font-medium duration-300 disabled:opacity-60 disabled:cursor-not-allowed disabled:media-hover:hover:bg-gray-900"
    >
      {text}
      {externalLink ? (
        <ExternalLinkIcon
          extraClass={`${
            websiteType === "petrotec-group"
              ? "stroke-gray-100"
              : "stroke-theme-color"
          }`}
        />
      ) : (
        <InternalLinkIcon
          extraClass={`${
            websiteType === "petrotec-group"
              ? "stroke-gray-100"
              : "stroke-theme-color"
          }`}
        />
      )}
    </button>
  );
};
